var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1074_5515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 8.25C15.25 8.44891 15.171 8.63968 15.0303 8.78033C14.8897 8.92098 14.6989 9 14.5 9H2.5C2.30109 9 2.11032 8.92098 1.96967 8.78033C1.82902 8.63968 1.75 8.44891 1.75 8.25C1.75 8.05109 1.82902 7.86032 1.96967 7.71967C2.11032 7.57902 2.30109 7.5 2.5 7.5H14.5C14.6989 7.5 14.8897 7.57902 15.0303 7.71967C15.171 7.86032 15.25 8.05109 15.25 8.25ZM18.25 3H-1.25C-1.44891 3 -1.63968 3.07902 -1.78033 3.21967C-1.92098 3.36032 -2 3.55109 -2 3.75C-2 3.94891 -1.92098 4.13968 -1.78033 4.28033C-1.63968 4.42098 -1.44891 4.5 -1.25 4.5H18.25C18.4489 4.5 18.6397 4.42098 18.7803 4.28033C18.921 4.13968 19 3.94891 19 3.75C19 3.55109 18.921 3.36032 18.7803 3.21967C18.6397 3.07902 18.4489 3 18.25 3ZM10.75 12H6.25C6.05109 12 5.86032 12.079 5.71967 12.2197C5.57902 12.3603 5.5 12.5511 5.5 12.75C5.5 12.9489 5.57902 13.1397 5.71967 13.2803C5.86032 13.421 6.05109 13.5 6.25 13.5H10.75C10.9489 13.5 11.1397 13.421 11.2803 13.2803C11.421 13.1397 11.5 12.9489 11.5 12.75C11.5 12.5511 11.421 12.3603 11.2803 12.2197C11.1397 12.079 10.9489 12 10.75 12Z",
    fill: "#3F403F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1074_5515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltros);
export default __webpack_public_path__ + "static/media/filtros.a76acb6b416ece356e1f624aae8d3f5f.svg";
export { ForwardRef as ReactComponent };